import React, {useState, useEffect} from 'react';
import { Button } from '../index';
import { Modal, Form } from 'antd';
import {
  Select,
  SelectFile,
  Input
} from '../../components';
import * as profileService from 'services/profile.service';
import { customMessages } from 'utils';


const SubjectList = ['Talep', 'Şikayet','Öneri'];

const ContactUs = (props) => {
  const [modalSendUs, setModalSendUs] = useState(props.visible);
  const [form] = Form.useForm();
  const [additionalFile, setAdditionalFile]=useState([]);

  function onContactUsRequest(values) {
    values={...values, additionalFile:additionalFile};
    
    profileService.sendContactUsMail(values).then((res) => {
     
      setAdditionalFile(null);
      onCloseModal();
      Modal.success({
        title: 'Başarılı',
        content: 'Bize ulaşın talebiniz başarıyla gönderildi',
      });      
    })
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });  
    });
  }

  const onCloseModal = () =>
  {
    setModalSendUs(false);
    props.onClose();
  }



  useEffect(() => {
    if (!modalSendUs) {
        setAdditionalFile([""]);
        form.resetFields();
      }
    }, [modalSendUs]);

    useEffect(() => {
       setModalSendUs(props.visible);
    }, [props.visible]);
    

  return (
  
       <Modal
            className="modal--send-us"
            title="Bize Ulaşın "
            visible={modalSendUs}
            onCancel={() => onCloseModal()}
            footer={[
              <div className="modal-action">
                <Button
                  shape="round"
                  type="ghost"
                  onClick={() => onCloseModal()}
                >
                  Vazgeç
                </Button>
                <Button
                  key="confirm"
                  htmlType="submit"
                  form="contactUs"
                >
                  Gönder
                </Button>
              </div>,
            ]}
          >
            <div>
              <Form form={form} 
                    name="choose-title" id="contactUs"  
                    onFinish={(values)=>onContactUsRequest(values)}>
                <Form.Item
                  rules={[{ required: true }]}
                  name="email"
                  messageVariables={{ label: 'e-mail' }}
                >
                  <Input
                    type="mail"
                    name="email"
                    label="E-Posta Adresiniz"
                  />
                </Form.Item>
                <Form.Item
                  rules={[{ required: true }]}
                  name="selectedSubject"
                  messageVariables={{ label: 'subject' }}
                >
                  <Select
                    label="Mesajınızın Konusu"
                    data={SubjectList}
                  ></Select>
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="messageText">
                  <Input.TextArea
                    autoComplete="off"
                    placeholder="Mesajınızı yazın"
                    className="textarea--v2"
                    name="messageText"
                  />
                </Form.Item>
                <Form className="Item">
                  <SelectFile allowExtensions={['jpg', 'gif', 'png','jpeg','doc','docx','xls','xlsx','pdf','rar','zip','csv']}
                    iconless
                    type="file"
                    title={<span>Dosya Yükle</span>}
                    onChange={(e)=> {setAdditionalFile(e.files[0])}}
                  />
                </Form>
              </Form>
            </div>
          </Modal>
  );
};

export default ContactUs;
